module.exports = __webpack_public_path__ + "img/流体力学4_2_3.d24964ff.jpg";